import React, { useContext, useMemo, useState } from "react";
import { remove } from "@/components/Joyspace/api/collections";
import { PageType } from "@/components/Joyspace/const";
import events from "@/components/Joyspace/context/events";
import { Icons } from "@/components/Joyspace/Icon";
import api from "../../../api";
import { message, Modal, Popover } from "antd";
import context, { useTranslation } from "../../../context";
import IconFont from "@/components/icon";
import { ActionFnEnum, ActionType, ContextMenuMode, FileType } from "@/components/Joyspace/types";

const { confirm } = Modal;
import "./index.less";
import GlobalContext from "@/context/GlobalContext";

interface IProps {
  contextMenuMode: ContextMenuMode;
  data: any;
  fileType: FileType;
  onChange?: () => void;
  callbackProps?: any;
}

export default function CollectionPopover(props: IProps) {
  const lang = useTranslation();
  const { data, fileType = FileType.Page, onChange, callbackProps, contextMenuMode } = props;
  const [popoverVisible, setPopoverVisible] = useState<boolean>(false);
  const [disabled, setDisabled] = useState(false);
  const { onLine } = useContext(GlobalContext);

  const handleVisibleChange = (visible = false) => {
    setPopoverVisible(visible);
  };
  const content = useMemo(() => {
    return (
      <ul
        className={
          disabled
            ? "joyspace-operate-lists joyspace-operate-lists-disabled"
            : "joyspace-operate-lists"
        }
        onContextMenu={(event) => {
          event.stopPropagation();
        }}
      >
        <li
          onClick={() => {
            if (disabled) {
              return;
            }
            handleVisibleChange(false);
            const title = data.title || "无标题";
            confirm({
              content: `${lang("common.confirm")}${lang("trashes.restore")}“${title}” ？`,
              okText: lang("common.confirm"),
              cancelText: lang("common.cancel"),
              onOk() {
                api.trashes.restore(data.id).then((data1) => {
                  // console.log(data1.fullName, 'fullName');
                  const fullName = data1.fullName.replace(/\$\@\$/g, "/");

                  message.success(`已将【${title}】恢复到【${fullName}】`);
                  callbackProps?.setData({
                    type: ActionFnEnum.REMOVE,
                    id: data.id,
                    actionType: ActionType.Page
                  } as any);
                });
              }
            });
          }}
        >
          <IconFont type="iconpc_yundoc_huifu" className="joyspace-trashes-operate-icon" />
          恢复
        </li>
        <li
          onClick={() => {
            if (disabled) {
              return;
            }
            handleVisibleChange(false);
            const tips = (
              <div style={{ overflow: "hidden" }}>
                {lang("trashes.confirmDelete")}
                {data.title || "无标题"}
              </div>
            );
            confirm({
              content: tips,
              okText: lang("common.confirm"),
              cancelText: lang("common.cancel"),
              onOk() {
                api.trashes.remove(data.id).then(() => {
                  message.success(lang("common.success"));
                  callbackProps?.setData({
                    type: ActionFnEnum.REMOVE,
                    id: data.id,
                    actionType: ActionType.Page
                  } as any);
                });
              }
            });
          }}
        >
          <IconFont type="iconpc_yundoc_recycle" className="joyspace-trashes-operate-icon" />
          删除
        </li>
      </ul>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callbackProps, data.id, data.title, disabled, lang]);
  useMemo(() => {
    setDisabled(!onLine);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);
  if (contextMenuMode === ContextMenuMode.ContextMenu) {
    return <div className="trashes-contextMenu">{content}</div>;
  }
  return (
    <div>
      <Popover
        trigger="click"
        placement="bottomRight"
        overlayClassName="trashes-popover"
        onVisibleChange={handleVisibleChange}
        visible={popoverVisible}
        content={content}
      >
        <a
          href="#"
          type="default"
          onContextMenu={(event) => {
            event.stopPropagation();
          }}
        >
          <span
            className={
              popoverVisible
                ? "joyspace-trigger-icon joyspace-trigger-actions"
                : "joyspace-trigger-icon"
            }
          >
            {Icons.trigger}
          </span>
        </a>
      </Popover>
    </div>
  );
}
